import { ComponentProps } from "react"

import type { AnyFieldApi } from "@tanstack/react-form"

import { Label } from "@/components/ui/Label"
import { cn } from "@/lib/shadcn-utils"

interface FormLabelProps extends ComponentProps<typeof Label> {
  field: AnyFieldApi
  label: string
}

export function FormLabel({
  field,
  label,
  className,
  ...props
}: FormLabelProps) {
  return (
    <Label
      htmlFor={field.name}
      className={cn("tw-font-medium tw-text-gray-700", className)}
      {...props}
    >
      {label}
    </Label>
  )
}
